import { minutesFromDayStart } from './dateGrid';

export function minutesToPx(minutes: number, pxPerMinute: number): number {
  return minutes * pxPerMinute;
}

export function pxToMinutes(px: number, pxPerMinute: number): number {
  return px / pxPerMinute;
}

export function dateToTopPx(
  date: Date,
  dayStart: Date,
  pxPerMinute: number,
  timeZone: string
): number {
  return minutesToPx(minutesFromDayStart(date, dayStart, timeZone), pxPerMinute);
}

export function snapMinutes(minutes: number, snapToMinutes: number): number {
  return Math.round(minutes / snapToMinutes) * snapToMinutes;
}
